import { Icon, IconProps } from '@ui/components';
import { cn } from '@ui/lib/utils';

export type DismissProps = Pick<IconProps, 'onClick' | 'className'>;

export const Dismiss = ({ onClick, className }: DismissProps) => {
  return (
    <Icon
      onClick={onClick}
      fileName="ic_x"
      className={cn(
        'cursor-pointer text-on-primary-surface-subdued',
        className,
      )}
    />
  );
};
